/* LUXE Night 1.0 · Cart, drawer, product form, motion. No dependencies. */
(function () {
  'use strict';
  var LX = window.LX || { routes: { root: '/', cart: '/cart', add: '/cart/add', change: '/cart/change' }, t: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (LX.routes.root || '/').replace(/\/?$/, '/');

  /* Toast */
  function toast(msg) {
    var t = $('.lx-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* Drawer */
  var lastFocus = null;
  function drawer() { return $('#lx-drawer'); }
  function openDrawer() {
    var d = drawer(); if (!d) { location.href = LX.routes.cart; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lx-lock');
    var c = $('[data-drawer-close].lx-icon-btn', d); if (c) setTimeout(function () { c.focus(); }, 60);
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lx-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function syncCount() {
    var p = $('.lx-drawer__panel'); var n = p ? parseInt(p.getAttribute('data-count') || '0', 10) : 0;
    $$('[data-cart-count]').forEach(function (e) { e.textContent = n; e.hidden = n === 0; });
  }
  function swap(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var np = $('.lx-drawer__panel', doc), p = $('.lx-drawer__panel');
    if (!np || !p) return false;
    p.replaceWith(np); syncCount(); return true;
  }
  function refresh() {
    return fetch(root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { swap(j['cart-drawer']); })
      .catch(function () {});
  }
  function post(url, body) {
    return fetch(url + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function add(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return post(LX.routes.add, { items: items, sections: 'cart-drawer', sections_url: location.pathname })
      .then(function (j) {
        if (j.status) { toast(j.description || j.message || LX.t.error); return; }
        if (!swap(j.sections && j.sections['cart-drawer'])) refresh();
        if (btn) {
          btn.classList.add('is-done');
          var tx = $('.lx-add__txt, .lx-btn__txt', btn); var o = tx && tx.textContent;
          if (tx) tx.textContent = LX.t.added || 'נוסף ✓';
          setTimeout(function () { btn.classList.remove('is-done'); if (tx) tx.textContent = o; }, 1800);
        }
        openDrawer();
        document.dispatchEvent(new CustomEvent('lx:cart', { detail: j }));
      })
      .catch(function () { toast(LX.t.error); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  function change(line, qty) {
    var p = $('.lx-drawer__panel'); if (p) p.classList.add('is-busy');
    return post(LX.routes.change, { line: line, quantity: qty, sections: 'cart-drawer', sections_url: location.pathname })
      .then(function (j) {
        if (j.status) { toast(j.description || j.message || LX.t.error); }
        if (!swap(j.sections && j.sections['cart-drawer'])) refresh();
      })
      .catch(function () { toast(LX.t.error); refresh(); });
  }
  window.LuxeCart = { add: function (id, btn) { return add([{ id: Number(id), quantity: 1 }], btn); }, open: openDrawer, close: closeDrawer, refresh: refresh, toast: toast };

  /* Clicks */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var b = t.closest('[data-luxe-add]');
    if (b) { e.preventDefault(); add([{ id: Number(b.getAttribute('data-luxe-add')), quantity: 1 }], b); return; }
    if (t.closest('[data-cart-open]') && drawer()) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    var q = t.closest('[data-line]');
    if (q) { e.preventDefault(); change(Number(q.getAttribute('data-line')), Number(q.getAttribute('data-qty'))); return; }
    var c = t.closest('[data-luxe-code]');
    if (c) {
      e.preventDefault(); c.disabled = true;
      var code = c.getAttribute('data-luxe-code') || LX.code;
      fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).finally(function () {
        try { localStorage.setItem('luxe_code', code); } catch (err) {}
        toast(LX.t.code); refresh();
      });
      return;
    }
    var m = t.closest('[data-menu-toggle]');
    if (m) { e.preventDefault(); var menu = $('#lx-menu'); if (!menu) return; var on = !menu.classList.contains('is-open'); menu.classList.toggle('is-open', on); menu.setAttribute('aria-hidden', on ? 'false' : 'true'); document.documentElement.classList.toggle('lx-lock', on); $$('[data-menu-toggle]').forEach(function (x) { x.setAttribute('aria-expanded', on); }); return; }
    var th = t.closest('[data-thumb]');
    if (th) { var i = Number(th.getAttribute('data-thumb')); var s = $('.lx-pm__slides'); if (s && s.children[i]) { s.scrollTo({ left: s.children[i].offsetLeft, behavior: 'smooth' }); $$('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === th); }); } }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    var menu = $('#lx-menu'); if (menu && menu.classList.contains('is-open')) { menu.classList.remove('is-open'); document.documentElement.classList.remove('lx-lock'); }
  });

  /* Product form */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-product-form]');
    if (!f) return;
    e.preventDefault();
    var id = f.querySelector('[name="id"]'); var qty = f.querySelector('[name="quantity"]');
    add([{ id: Number(id.value), quantity: Math.max(1, Number(qty ? qty.value : 1)) }], f.querySelector('[type="submit"]'));
  });
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-variant-select]');
    if (!s) return;
    var o = s.options[s.selectedIndex]; var f = s.closest('form');
    var price = document.querySelector('[data-price]'); if (price && o.dataset.price) price.textContent = o.dataset.price;
    var btn = f && f.querySelector('[type="submit"]');
    if (btn) { var ok = o.dataset.available === 'true'; btn.disabled = !ok; var tx = btn.querySelector('.lx-btn__txt'); if (tx) tx.textContent = ok ? btn.dataset.label : btn.dataset.soldout; }
    var url = new URL(location.href); url.searchParams.set('variant', s.value); history.replaceState(null, '', url);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]'); if (!b) return;
    var i = b.parentElement.querySelector('input'); if (!i) return;
    i.value = Math.max(1, (Number(i.value) || 1) + Number(b.getAttribute('data-qty-step')));
  });

  /* Header + reveal */
  function onScroll() { var h = $('.lx-header'); if (h) h.classList.toggle('is-scrolled', window.scrollY > 12); }
  window.addEventListener('scroll', onScroll, { passive: true });
  function reveal() {
    var els = $$('.lx-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  function init() { onScroll(); reveal(); syncCount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', reveal);
})();
